import classNames from 'classnames';
import { ButtonHTMLAttributes, FC } from 'react';

import css from './close-button.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  isDefault?: boolean;
}

const CloseButton: FC<Props> = ({ className, isDefault = false, type = 'button', ...rest }) => {
  if (isDefault) {
    return <button type={type} className={classNames(css.closeButtonDefault, className)} {...rest} />;
  }

  return (
    <button type={type} className={classNames(css.closeButton, 'close-button', className)} {...rest}>
      <span className={classNames(css.closeButtonSpan, css.closeButtonSpanDark)} />
      <span className={classNames(css.closeButtonSpan, css.closeButtonSpanRotate, css.closeButtonSpanDark)} />
    </button>
  );
};

export default CloseButton;
